const getIds = (data) => {
  if (data == null) return [];
  if (!Array.isArray(data)) return [];
  return data.map((item, idx) => item?.id || idx);
};

export default getIds;
